"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
//used in search in section/header.liquid
var DetailsModal = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DetailsModal, _HTMLElement);
  var _super = _createSuper(DetailsModal);
  function DetailsModal() {
    var _this;
    _classCallCheck(this, DetailsModal);
    _this = _super.call(this);
    _this.detailsContainer = _this.querySelector('details');
    _this.summaryToggle = _this.querySelector('summary');
    _this.detailsContainer.addEventListener('keyup', function (event) {
      return event.code.toUpperCase() === 'ESCAPE' && _this.close();
    });
    _this.summaryToggle.addEventListener('click', _this.onSummaryClick.bind(_assertThisInitialized(_this)));
    var closeButton = _this.querySelector('button[type="button"]');
    if (closeButton) closeButton.addEventListener('click', _this.close.bind(_assertThisInitialized(_this)));
    _this.summaryToggle.setAttribute('role', 'button');
    _this.overlay = _this.querySelector('.search-modal__overlay');
    _this._overlayAnimation = null;
    if (_this.overlay) {
      _this.overlay.addEventListener('click', _this.close.bind(_assertThisInitialized(_this), false));
    }
    return _this;
  }
  _createClass(DetailsModal, [{
    key: "isOpen",
    value: function isOpen() {
      return this.detailsContainer.hasAttribute('open');
    }
  }, {
    key: "onSummaryClick",
    value: function onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
    }
  }, {
    key: "onBodyClick",
    value: function onBodyClick(event) {
      if (!this.contains(event.target)) this.close(false);
    }
  }, {
    key: "open",
    value: function open(event) {
      if (window.innerWidth <= 989) {
        var cartModal = document.querySelector('cart-modal');
        if (cartModal && cartModal.classList.contains('active')) cartModal.close();
      }
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest('details').setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');
      trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), this.detailsContainer.querySelector('input:not([type="hidden"])'));
      if (this.overlay) {
        this.overlay.style.pointerEvents = 'auto';
        if (this._overlayAnimation) this._overlayAnimation.cancel();
        this._overlayAnimation = this.overlay.animate([{
          opacity: 0
        }, {
          opacity: 1
        }], {
          duration: 300,
          fill: 'forwards'
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;
      var focusToggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
      if (this.overlay) {
        this.overlay.style.pointerEvents = 'none';
        if (this._overlayAnimation) this._overlayAnimation.cancel();
        this._overlayAnimation = this.overlay.animate([{
          opacity: 1
        }, {
          opacity: 0
        }], {
          duration: 300,
          fill: 'forwards'
        });
      }
      var panel = this.detailsContainer.querySelector('.search-modal');
      if (panel) {
        var anim = panel.animate([{
          opacity: 1
        }, {
          opacity: 0
        }], {
          duration: 250,
          fill: 'forwards'
        });
        anim.onfinish = function () {
          _this2.detailsContainer.removeAttribute('open');
          anim.cancel();
        };
      } else {
        this.detailsContainer.removeAttribute('open');
      }
    }
  }]);
  return DetailsModal;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('details-modal', DetailsModal);